import { getOSType } from './getOSType';

export const isIOS = getOSType() === 'iOS';
